import TransferForm from "../pages/TransferForm";
const Banner = () => {
  return (
    <section className="relative w-full overflow-hidden border-b border-[#e8dfd2] bg-[#f7f3ed] text-[#302521]">
      <div className="pointer-events-none absolute -right-32 top-24 h-96 w-96 rounded-full bg-[#882699]/[0.06] blur-3xl" />
      <div className="pointer-events-none absolute -left-40 bottom-0 h-96 w-96 rounded-full bg-[#cbbca9]/40 blur-3xl" />
      <div className="relative z-10 px-4 pb-20 pt-8 sm:px-6 md:pb-24 md:pt-10">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-12">
          <div data-reveal="left" className="mx-auto max-w-2xl text-center lg:mx-0 lg:text-left">
            <h1 className="text-4xl font-bold leading-[1.12] tracking-tight sm:text-5xl">
              Send love home,
              <br className="hidden sm:block" /> one clear transfer at a time.
            </h1>
            <p className="mx-auto mt-4 max-w-lg text-sm leading-6 text-[#766b64] sm:text-base lg:mx-0">
              Check the rate and fee first, then send to family and friends
              abroad.
            </p>
            <ul className="mx-auto mt-6 max-w-lg space-y-3 text-left text-sm text-[#514641] sm:text-base lg:mx-0">
              {[
                "Rate and fee shown before you pay",
                "Protected payments and identity checks",
                "Support when you need it",
              ].map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#f0e5f3] text-[#882699]">
                    <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m5 12 4 4L19 6" />
                    </svg>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div data-reveal="right" data-reveal-delay="2" className="relative mx-auto min-h-[500px] w-full max-w-[560px] lg:my-[-8px]">
          <div className="pointer-events-none absolute left-1/2 top-[48%] hidden h-[460px] w-[460px] -translate-x-1/2 -translate-y-1/2 md:block">
            <svg
              className="h-full w-full text-[#c8bbae]/70"
              viewBox="0 0 540 540"
              fill="none"
              aria-hidden="true"
            >
              <circle cx="270" cy="270" r="268" stroke="currentColor" />
              <ellipse cx="270" cy="270" rx="268" ry="88" stroke="currentColor" />
              <ellipse
                cx="270"
                cy="270"
                rx="88"
                ry="268"
                stroke="currentColor"
                transform="rotate(45 270 270)"
              />
              <path d="M2 270h536M270 2v536" stroke="currentColor" />
            </svg>
          </div>

          <div className="pointer-events-none absolute -left-[30%] top-[8%] z-20 hidden items-center gap-2 rounded-2xl border border-[#e5dbcf] bg-[#fffdf9]/95 px-3 py-2.5 shadow-[0_10px_30px_rgba(66,48,34,0.1)] 2xl:flex">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#e2f1e6] text-[#27613b]">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="m5 12 4 4L19 6" />
              </svg>
            </span>
            <span>
              <span className="block text-[11px] font-semibold text-[#302521]">Payment received</span>
              <span className="block text-[10px] text-[#766b64]">105.00 CAD</span>
            </span>
          </div>

          <div className="pointer-events-none absolute -right-[30%] top-[62%] z-20 hidden items-center gap-2 rounded-2xl border border-[#e5dbcf] bg-[#fffdf9]/95 px-3 py-2.5 shadow-[0_10px_30px_rgba(66,48,34,0.1)] 2xl:flex">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#f0e5f3] text-[#882699]">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 3-7.5 18-3.8-7.7L2 9.5 21 3Z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="m9.7 13.3 4.8-4.8" />
              </svg>
            </span>
            <span>
              <span className="block text-[11px] font-semibold text-[#302521]">On its way</span>
              <span className="block text-[10px] text-[#766b64]">1,050 NKF to recipient</span>
            </span>
          </div>

          <div className="pointer-events-none absolute -left-[26%] bottom-[12%] z-20 hidden items-center gap-2 rounded-2xl border border-[#e5dbcf] bg-[#fffdf9]/95 px-3 py-2.5 shadow-[0_10px_30px_rgba(66,48,34,0.1)] 2xl:flex">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#f0e5f3] text-[#882699]">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                <rect x="5" y="10" width="14" height="11" rx="2" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 10V7a4 4 0 1 1 8 0v3" />
              </svg>
            </span>
            <span className="text-[11px] font-semibold text-[#302521]">Secure checkout</span>
          </div>

          <div className="pointer-events-none absolute -right-[12%] top-[2%] z-20 hidden h-12 w-12 items-center justify-center rounded-full border border-[#e5dbcf] bg-[#fffdf9] shadow-[0_10px_30px_rgba(66,48,34,0.1)] 2xl:flex">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#f0e5f3] text-[#882699]">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="m3 11 9-8 9 8M5 10v10h14V10M9 20v-6h6v6" />
              </svg>
            </span>
          </div>

          <div className="relative z-10 mx-auto mt-4 w-full max-w-[392px] rounded-[1.25rem] border border-[#563D63] bg-[#2E1A3A] p-4 shadow-[0_24px_64px_rgba(0,0,0,0.28)]">
            <TransferForm type="homePage" amtData={""} />
            <p className="pb-1 text-center text-[11px] text-[#CBB7D8]">
              Rates shown are examples and may change.
            </p>
          </div>

          </div>
        </div>

        <div data-reveal="up" className="mx-auto mt-12 max-w-[680px] text-center sm:mt-14">
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#882699]">
              Our services
            </p>
            <h2 className="mt-2 text-xl font-semibold tracking-tight text-[#302521] sm:text-2xl">
              Proudly serving countries
            </h2>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-2 gap-y-3 sm:flex-nowrap sm:gap-x-0">
              {[
                { name: "Cameroon", src: "/Cameroon.png", tilt: "-rotate-[8deg]" },
                { name: "Ethiopia", src: "/Ethiopia.png", tilt: "rotate-[6deg]" },
                { name: "Eritrea", src: "/Eritrea.png", tilt: "-rotate-[5deg]" },
                { name: "Sudan", src: "/Sudan.png", tilt: "rotate-[7deg]" },
                { name: "Uganda", src: "/Uganda.png", tilt: "-rotate-[4deg]" },
              ].map(({ name, src, tilt }) => (
                <img
                  key={name}
                  src={src}
                  alt={name}
                  className={`relative h-[54px] w-[92px] rounded-xl object-cover shadow-[0_8px_18px_rgba(48,37,33,0.16)] transition duration-300 ease-out hover:z-10 hover:-translate-y-2 hover:scale-110 hover:rotate-0 hover:shadow-[0_14px_24px_rgba(48,37,33,0.22)] sm:-ml-2 sm:h-[64px] sm:w-[108px] ${tilt}`}
                />
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
